import React from 'react'
import HomeBanner from './HomeBanner'
import HomeProduct from './HomeProduct'
import HomeRecommended from './HomeRecommended'
import HomeOfferBanner from './HomeOfferBanner'
import HomeCategory from './HomeCategory'

const Home = () => {
  return (
    <>
      <HomeBanner />
      <HomeCategory />
      <HomeProduct />
      <HomeOfferBanner />
      <HomeRecommended />
    </>
  )
}

export default Home